import React from 'react';

import { Link, Typography } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../theme/color-palette';
import { useHistory } from 'react-router-dom';

const styles = makeStyles(() => ({
	inactive: {
		textTransform: 'capitalize',
		fontSize: '14px',
		color: colors.BREADCRUMB_INACTIVE,
		textDecoration: 'none',
		'&:hover': {
			cursor: 'pointer',
		},
	},
	active: {
		textTransform: 'capitalize',
		textDecoration: 'none',
		fontSize: '14px',
		color: colors.BREADCRUMB_ACTIVE,
	},
}));

export const BreadcrumbUtils = () => {
	const classes = styles();
	const navigate = useHistory();

	let matched = false;
	const location = useLocation();
	const pathname = location?.pathname;

	let { type, id, name, itemId, itemName, identified, anomalyChange } =
		useParams();

	itemName = itemName?.replace('%2F', '/');
	const urlNameItem = itemName?.replace('/', '%2F');

	let breadcrumbNameMap =
		pathname.includes('/details/root-cause-analysis') && itemId === undefined
			? {
					'/dashboard/guided-insights': 'Guided Insights',
					[`/details/root-cause-analysis/${type}/${id}/${name}/${identified}/anomalyChange/${anomalyChange}`]: `${type}: ${id} ${name}`,
			  }
			: pathname.includes('/details/root-cause-analysis') && itemId
			? {
					'/dashboard/guided-insights': 'Guided Insights',
					[`/details/root-cause-analysis/${type}/${id}/${name}/${identified}/anomalyChange/${anomalyChange}`]: `${type}: ${id} ${name}`,
					[`/details/root-cause-analysis/${type}/${id}/${name}/${identified}/anomalyChange/${anomalyChange}/item-details/${itemId}/${urlNameItem}`]: `Item: ${itemId} ${itemName}`,
			  }
			: pathname.includes('details/item-details')
			? {
					'/dashboard': 'Dashboard',
					[`/details/item-details/${itemId}/${urlNameItem}`]: `Item: ${itemId} ${itemName}`,
			  }
			: pathname.includes('/details/store-drilldown')
			? {
					'/dashboard/guided-insights': 'Guided Insights',
					[`/details/root-cause-analysis/${type}/${id}/${name}/${identified}/anomalyChange/${anomalyChange}`]: `${type}: ${id} ${name}`,
					[' ']: ' ',
			  }
			: null;

	const breadcrumbs = [];
	Object.keys(breadcrumbNameMap).forEach((item, idx) => {
		if (!matched && item) {
			breadcrumbs.push(
				<Link
					key={idx}
					underline="none"
					color="inherit"
					onClick={() => {
						navigate.push({
							pathname: item,
						});
					}}>
					<Typography
						sx={{
							fontSize: '14px',
							lineHeight: '20px',
							textTransform: 'capitalize',
						}}
						className={item === pathname ? classes.active : classes.inactive}>
						{breadcrumbNameMap[item]?.toLocaleLowerCase()}
					</Typography>
				</Link>
			);
			if (item === pathname) {
				matched = true;
			}
		}
	});

	return breadcrumbs;
};
